import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../../../../../components/shared/Button/Button';
import CustomPasswordField from '../../../../../components/shared/CustomPasswordField/CustomPasswordField';
import Modal from '../../../../../components/shared/Modal/Modal';
import { IsMobile } from '../../../../../helpers/IsMobile';

import styles from './PrimaryEmailModal.module.scss';

const PrimaryEmailModal = ({ show, onHide, handleSubmit }) => {
  const { t } = useTranslation('common');
  const modalFullScreen = IsMobile();

  const [pass, setPass] = useState('');

  return (
    <Modal show={show} onHide={onHide} size="lg" centered fullscreen={modalFullScreen}>
      <Modal.CustomHeader closeButton>
        <Modal.Title>{t('emailModals.enterPassword')}</Modal.Title>
      </Modal.CustomHeader>

      <div className={styles.modalContainer}>
        <Modal.Body>
          <div className={styles.container}>
            <div className={styles.modalContent}>
              <span className={styles.header}>{t('emailModals.verifyPassword')}</span>
              <CustomPasswordField
                value={pass}
                onChange={(e) => setPass(e.target.value)}
                label={t('closeAccount.enterPassword')}
              />
            </div>
          </div>
        </Modal.Body>

        <div className={styles.modalFooter}>
          <Modal.CustomFooter>
            <Button variant="secondary" onClick={onHide}>
              {t('cancel')}
            </Button>
            <Button variant="outline-primary" onClick={() => handleSubmit(pass)}>
              {t('confirm')}
            </Button>
          </Modal.CustomFooter>
        </div>
      </div>
    </Modal>
  );
};

export default PrimaryEmailModal;
